<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">用户组名：</div>
                        <el-input v-model="artName" placeholder="请输入用户组名" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6" :offset="10">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 新增 -->
        <div class="whiteBg main-middle">
            <div class="box box-align-center mt-btns">
                <el-button type="primary" plain icon="el-icon-plus" @click="buildNewTopic">新增用户组</el-button>
            </div>
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" v-loading="tableLoading"
                :total="total" :page-num="currentPage" :page-size="pageSize" @current-change="onCurrentChange"
                element-loading-text="加载中"></dy-table>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="40%" :close-on-click-modal="false">
            <el-form>
                <el-form-item label="用户组名：">
                    <el-input v-model="groupName" placeholder="请输入用户组名"></el-input>
                </el-form-item>
                <div class="box box-align-center box-pack-end mt-btns mt24" style="margin-right: 30px;">
                    <el-button type="primary" plain @click="submitForm()">保存</el-button>
                    <el-button type="danger" plain @click="() => addVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="权限分配" :visible.sync="rightVisible" width="50%" :close-on-click-modal="false">
            <el-tree :data="treeData" ref="treeRef" node-key="id" accordion show-checkbox @check="handleCheckChange">
            </el-tree>
            <div class="box box-align-center box-pack-end mt-btns mt24" style="margin-right: 30px;">
                <el-button type="primary" plain @click="trueSetRight">保存</el-button>
                <el-button type="danger" plain @click="() => rightVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'

import host from '@/api/index';
import { queryGroup, updateGroup, addGroup, queryGroupDetails } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

var that = null;
export default {
    components: {
        DyTable,
    },
    data() {
        const { doEdit } = this;
        const { doRight } = this;
        const { doDelete } = this;
        const { changeGroupStatus } = this;
        return {
            artName: '',
            tableLoading: true,
            dialogTitle: '新建用户组',
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'groupName',
                    title: '用户组名'
                },
                {
                    key: 'groupStatus',
                    title: '状态',
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-switch
                                    value={row.groupStatus == 1 ? true : false}
                                    onChange={() => changeGroupStatus(row)}
                                />
                            </div>
                        );
                    }
                },
                {
                    key: '',
                    title: '操作',
                    width: 200,
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-link type="primary" onClick={() => doEdit(row)}>编辑</el-link>
                                <el-link type="warning" style="margin-left:12px" onClick={() => doRight(row)}>权限分配</el-link>
                            </div>
                        );
                    }
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            ruleForm: {//新建表单数据
                buttonId: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                desc: [{ required: true, message: '请输入描述信息', trigger: 'blur' }],
            },
            addVisible: false,
            status: null,
            groupName: '',
            currentGroup: null,
            rightVisible: false,//权限分配
            treeData: [],
            menusList: [],//分配权限列表数据
        }
    },
    mounted() {
        that = this;
        that.getList();
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token') // 直接从本地获取token就行
            };
        }
    },
    methods: {
        // 确定分配权限
        trueSetRight() {
            let info = {
                groupName: that.currentGroup.groupName,
                groupId: that.currentGroup.groupId,
                groupStatus: that.currentGroup.groupStatus,
                isDelete: 0,
                menus: that.menusList,
                needAuthority: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            updateGroup(data).then((res) => {
                this.$message({
                    showClose: true,
                    message: '分配成功',
                    type: 'success'
                });
                that.rightVisible = false;
                that.getList();
            });
        },
        // 获取权限数据
        handleCheckChange(checkedNodes, checkedKeys) {
            console.log(checkedNodes, checkedKeys);
            that.menusList = checkedKeys.checkedKeys;
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].subs != '' && arr[i].subs != null && arr[i].subs != undefined) {
                        children.push({
                            id: arr[i].id,
                            label: arr[i].title,
                            children: this.listFor(arr[i].subs),
                        });
                    } else {
                        if (arr[i].id != 0) {
                            children.push({
                                id: arr[i].id,
                                label: arr[i].title,
                                children: this.listFor(arr[i].subs),
                            });
                        }
                    }
                }
            } else {
                return;
            }
            return children;
        },
        //权限分配
        doRight(obj) {
            console.log('权限分配', obj);
            that.currentGroup = obj;
            let arr = JSON.parse(localStorage.getItem('menuList'));
            that.treeData = that.listFor(arr);
            console.log('treeData', that.treeData);
            let info = {
                groupId: obj.groupId
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryGroupDetails(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('已选权限', ress.menuList);
                    that.rightVisible = true;
                    that.$nextTick(() => {
                        that.$refs.treeRef.setCheckedKeys(ress.menuList);
                    });
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // 切换按钮
        changeGroupStatus(obj) {
            console.log(obj);
            let info = {
                groupName: obj.groupName,
                groupId: obj.groupId,
                groupStatus: obj.groupStatus == 1 ? 0 : 1,
                isDelete: 0,
                menus: '',
                needAuthority: false
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            updateGroup(data).then((res) => {
                this.$message({
                    showClose: true,
                    message: '修改成功',
                    type: 'success'
                });
                that.getList();
            });
        },
        //新建
        buildNewTopic() {
            that.dialogTitle = '新建用户组';
            that.ruleForm = {
                buttonId: '',
            }
            that.groupName = '';
            that.currentGroup = null;
            that.addVisible = true;
        },
        //重置列表
        resetList() {
            that.currentPage = 1;
            that.artName = '';
            that.getList();
        },
        //编辑
        doEdit(obj) {
            that.dialogTitle = '编辑用户组';
            console.log(obj, '编辑');
            that.currentGroup = obj;
            that.groupName = obj.groupName;
            that.addVisible = true;
        },
        //删除
        doDelete(obj) {
            that.$confirm('确认要删除此用户组吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    groupName: obj.groupName,
                    groupId: obj.groupId,
                    groupStatus: 0,
                    isDelete: 1,
                    menus: '',
                    needAuthority: false
                };
                console.log(info);
                var data = encrypt(JSON.stringify(info));
                updateGroup(data).then((res) => {
                    this.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success'
                    });
                    that.getList();
                });
            })
        },
        // 提交表单
        submitForm() {
            if (that.currentGroup) {//编辑
                let info = {
                    groupName: that.groupName,
                    groupId: that.currentGroup.groupId,
                    groupStatus: that.currentGroup.groupStatus,
                    isDelete: 0,
                    menus: '',
                    needAuthority: false
                };
                console.log(info);
                var data = encrypt(JSON.stringify(info));
                updateGroup(data).then((res) => {
                    that.addVisible = false;
                    that.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    that.getList();
                });
                return;
            }
            //新增
            var info = {
                groupName: that.groupName
            };
            console.log(info, '我是表单');
            var data = encrypt(JSON.stringify(info));
            addGroup(data).then((res) => {
                if (res.result == 1) {
                    console.log(res);
                    that.addVisible = false;
                    that.currentPage = 1;
                    that.getList();
                    that.$message({
                        showClose: true,
                        message: '保存成功',
                        type: 'success'
                    });
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });

        },
        onCurrentChange(val) {
            that.currentPage = val
            that.getList()
        },
        getList() {
            that.tableLoading = true;
            let info = {
                groupName: that.artName,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryGroup(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('列表', ress);
                    that.total = ress.total;
                    that.currentPage = ress.pageNum;
                    that.tableData = ress.list;
                    that.tableLoading = false;
                    that.chapterTableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
    min-width: 100px;
    text-align: center;
    padding: 0;
}

/deep/.el-dropdown {
    margin-right: 10px;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }
.main {
    padding-top: 0 !important;
    padding-right: 0 !important;
}

.main-top {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>